import { c as _c } from "react/compiler-runtime";
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { faTriangleExclamation, faCheckCircle, faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Box, BoxProps, Flex } from '../grid';
import { Theme, ThemeContext } from '@emotion/react';
import { themeGet } from '@styled-system/theme-get';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
interface CalloutProps {
  color?: string;
  size?: 'small' | 'medium' | 'large';
  theme?: Theme;
  close?: () => void;
  icon?: IconProp;
}
type Props = CalloutProps & BoxProps;
export function Callout(t0) {
  const $ = _c(27);
  let children;
  let close;
  let color;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      color,
      children,
      close,
      icon: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = close;
    $[3] = color;
    $[4] = props;
    $[5] = t1;
  } else {
    children = $[1];
    close = $[2];
    color = $[3];
    props = $[4];
    t1 = $[5];
  }
  const icon = t1 === undefined ? null : t1;
  const theme = React.useContext(ThemeContext as any);
  const t2 = color || "primary";
  let backgroundColor;
  let colorScaleName;
  if ($[6] !== t2 || $[7] !== theme) {
    const color_ = t2.split(".")[0];
    colorScaleName = {
      success: "green",
      warning: "yellow",
      alert: "red",
      info: "blue",
      primary: "primary_"
    }[color_] || color_;
    const isDark = theme.mode === "dark";
    if (!isDark) {
      backgroundColor = themeGet(`colors.${colorScaleName}.${isDark ? 6 : 0}`, colorScaleName)({
        theme
      });
    } else {
      backgroundColor = "gray.2";
    }
    $[6] = t2;
    $[7] = theme;
    $[8] = backgroundColor;
    $[9] = colorScaleName;
  } else {
    backgroundColor = $[8];
    colorScaleName = $[9];
  }
  const t3 = color !== "white" ? "heading" : "body";
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      color: "text"
    };
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== backgroundColor || $[12] !== t3) {
    t5 = {
      color: "primary",
      borderRadius: 2,
      px: 4,
      py: 4,
      fontSize: 2,
      fontFamily: t3,
      position: "relative",
      border: "text",
      backgroundColor,
      "&, & > svg": t4,
      borderColor: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      display: "flex",
      alignItems: "center",
      gap: 4
    };
    $[11] = backgroundColor;
    $[12] = t3;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== colorScaleName || $[15] !== icon) {
    t6 = (icon || ["yellow", "red", "green"].includes(colorScaleName)) && <Box color={`${colorScaleName}.5`}><FontAwesomeIcon icon={icon || {
        yellow: faTriangleExclamation,
        red: faTimes,
        green: faCheckCircle,
        blue: faCircleInfo
      }[colorScaleName]} /></Box>;
    $[14] = colorScaleName;
    $[15] = icon;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== children) {
    t7 = <Box flexGrow={1} alignItems="center">{children}</Box>;
    $[17] = children;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== close) {
    t8 = close && <Box as="button" className="close" onClick={close} alignItems="flex-start"><FontAwesomeIcon icon={faTimes} /></Box>;
    $[19] = close;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== props || $[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t9 = <Flex __css={t5} {...props}>{t6}{t7}{t8}</Flex>;
    $[21] = props;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}
export const WarningBox = t0 => {
  const $ = _c(9);
  let children;
  let close;
  let rest;
  if ($[0] !== t0) {
    ({
      close,
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = close;
    $[3] = rest;
  } else {
    children = $[1];
    close = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      alignItems: "center",
      a: {
        color: "#765b1e"
      }
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== children || $[6] !== close || $[7] !== rest) {
    t2 = <Callout {...rest} color="warning" sx={t1} close={close}>{children}</Callout>;
    $[5] = children;
    $[6] = close;
    $[7] = rest;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default Callout;